import React, { useState, useEffect } from 'react';
import { FaSun, FaMoon } from 'react-icons/fa';

const Header = () => {
  const [darkMode, setDarkMode] = useState(true);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setDarkMode(savedTheme === 'dark');
      document.documentElement.classList.toggle('dark', savedTheme === 'dark');
    }

    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleTheme = () => {
    setDarkMode(prevMode => {
      const newMode = !prevMode;
      localStorage.setItem('theme', newMode ? 'dark' : 'light');
      document.documentElement.classList.toggle('dark', newMode);
      return newMode;
    });
  };

  return (
    <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'glass shadow-sm' : 'bg-transparent'}`}>
      <nav className="flex justify-between items-center max-w-screen-xl mx-auto py-4 px-6">
        <div className="text-xl font-bold gradient-text tracking-tight">
          Safia Djenane
        </div>
        <ul className="hidden md:flex list-none gap-8 m-0 p-0">
          <li>
            <a href="#hero" className="text-sm font-medium text-textlight hover:text-primary transition-colors duration-200">Home</a>
          </li>
          <li>
            <a href="#services" className="text-sm font-medium text-textlight hover:text-primary transition-colors duration-200">Services</a>
          </li>
          <li>
            <a href="#portfolio" className="text-sm font-medium text-textlight hover:text-primary transition-colors duration-200">Portfolio</a>
          </li>
          <li>
            <a href="#about" className="text-sm font-medium text-textlight hover:text-primary transition-colors duration-200">About Me</a>
          </li>
        </ul>
        <div className="flex items-center gap-3">
          <button 
            onClick={toggleTheme} 
            className="p-2.5 rounded-full bg-accent hover:bg-border transition-colors duration-200 text-lg"
            aria-label="Toggle theme"
          >
            {darkMode ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-textlight" />}
          </button>
          <a 
            href="#contact" 
            className="hidden sm:inline-flex px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 bg-primary text-white hover:opacity-90 hover:shadow-lg hover:shadow-primary/25"
          >
            Contact Me
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;
